import { Schema, string, isodate, array } from 'lib/schema';

export default class UserProfile extends Schema {
  @string id = { default: null };

  @string user = { default: null };

  @isodate created = { default: () => new Date().toISOString() };

  @isodate modified = { mutable: true, default: () => new Date().toISOString() };

  @string avatar = { mutable: true, path: 'avatar.original', default: null };

  @array preferences = { mutable: true, default: () => [] };

  get shows() {
    const { permissions } = this.getState();

    if (!(permissions instanceof Array)) {
      return [];
    }

    return permissions.filter(p => p.resource === 'Channel').map(p => p.id);
  }

  get messages() {
    const { messages } = this.getState();

    if (!(messages instanceof Array)) {
      return [];
    }

    return JSON.parse(JSON.stringify(messages));
  }

  hasFeature(name) {
    return this.getState().groups.some(group => {
      return group.features.some(feature => feature.name === name);
    });
  }

  getPreference(name) {
    const preference = this.preferences.filter(pref => pref.name === name);
    if (preference) {
      return JSON.parse(JSON.stringify(preference));
    }
    return null;
  }
}
